export enum LicenseEnum {
  BASE = 'BASE',
  FREE = 'FREE',
}
